import { UserProfile } from "generated/graphql";

export { UserProfile };

export interface Credentials {
    /**
     * Expiration date of the credentials in ISO formatted string.
     */
    Expiration: string;
    /**
     * The access token that can be used to access stentor apis.
     */
    accessToken: string;
    /**
     * The token that is used to get a new access token when it expires.
     */
    refreshToken?: string;
}

export interface AuthState {
    /**
     * Allows admins to view the site as a user does.
     */
    asUser?: boolean;
    /**
     * This is the AWS ID of the AWS user.  This should be provided on login if the user
     * was navigated from the AWS Marketplace.  If this exists, the user should be linked
     * to the ID.
     *
     * @type {string}
     * @memberof AuthState
     */
    awsId?: string;
    /**
     * Holds any error that may occur.
     */
    error?: Error;
    /**
     * True if the user is currently logging in.
     */
    isLoggingIn?: boolean;
    /**
     * The current profile of the user.
     */
    profile?: UserProfile;
    /**
     * When using a Oauth2 code authorization, this is the code challenge that must be sent when
     * retrieving authorization tokens.
     */
    codeVerifier?: string;
    /**
     * The credentials of the user.
     */
    credentials?: Credentials;
    /**
     * If logging in, this will be the url the user is sent to when finished.
     */
    redirectUrl?: string;
    /**
     * If logging in, this is the state string to match against when the user is authorized.
     *
     * This string is sent to the auth provider when requesting authorization.  The auth provider
     * will collect the user's credentials and validate. It will then navigate back to the url defined
     * in the "redirectUrl" with the same string as a "state" parameter in the path. If the "state" parameter
     * does not match the "state" parameter saved here, then the user should not be authorized.
     */
    state?: string;
}

